import React, { useEffect, useMemo, useState } from 'react';
import { App, Empty, Table, Tag } from 'antd';
import dayjs from 'dayjs';
import { listClientSubscriptions } from '../../services/billing';

const { useApp } = App;

// Historial de suscripciones de un cliente
export default function ClientSubscriptionsHistory({ clientId }) {
    const { message } = useApp();
    const [subscriptions, setSubscriptions] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!clientId) return;
        (async () => {
            try {
                setLoading(true);
                const items = await listClientSubscriptions(clientId);
                setSubscriptions(Array.isArray(items) ? items : []);
            } catch (e) {
                console.error(e);
                message.error('No se pudo cargar el historial de suscripciones');
            } finally {
                setLoading(false);
            }
        })();
    }, [clientId, message]);

    const columns = useMemo(() => ([
        {
            title: 'Membresía',
            dataIndex: 'subscriptionName',
            key: 'subscriptionName',
            render: (value) => value || '-',
        },
        {
            title: 'Fecha de compra',
            dataIndex: 'purchaseDate',
            key: 'purchaseDate',
            render: (value) => (value ? dayjs(value).format('DD/MM/YYYY') : '-'),
        },
        {
            title: 'Fecha de expiración',
            dataIndex: 'expirationDate',
            key: 'expirationDate',
            render: (value) => (value ? dayjs(value).format('DD/MM/YYYY') : '-'),
        },
        {
            title: 'Estatus',
            dataIndex: 'status',
            key: 'status',
            render: (value) => {
                const normalized = String(value || '').toLowerCase();
                const isActive = normalized === 'vigente' || normalized === 'active' || normalized === 'activo'  || normalized === 'trial';
                const color = isActive ? 'green' : 'red';
                const label = value || '-';
                return <Tag color={color}>{label}</Tag>;
            },
        },
        {
            title: 'Medio de compra',
            dataIndex: 'medium',
            key: 'medium',
            render: (value) => value || '-',
        },
        {
            title: 'Pago',
            dataIndex: 'price',
            key: 'price',
            render: (value) => value != null 
                ? `$${Number(value).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}` 
                : '-',
        },
    ]), []);

    return (
        <div style={{ padding: '24px 0' }}>
            <Table
                rowKey={(row) => row.id ?? `${row.subscriptionName}-${row.purchaseDate}`}
                loading={loading}
                dataSource={subscriptions}
                columns={columns}
                pagination={false}
                locale={{
                    emptyText: <Empty description="Sin historial" />,
                }}
            />
        </div>
    );
}
